// Verified reviews — tied to a paid order in production (reviews container,
// pk: /productId). Only verified buyers can leave one; that's the trust layer.

export const REVIEWS = [
  {
    id: "r1",
    productId: "p-monstera-deliciosa",
    author: "Aoife, Tullamore",
    rating: 5,
    verified: true,
    body: "Genuinely the healthiest plant I've ever had delivered. Not a single bruised leaf.",
    deliveryConditionNote: "Arrived in perfect condition, beautifully packed.",
    date: "2026-05-02",
  },
  {
    id: "r2",
    productId: "p-monstera-deliciosa",
    author: "Cian, Athlone",
    rating: 5,
    verified: true,
    body: "Bigger than I expected and already pushing out a new leaf two weeks in.",
    deliveryConditionNote: "Box was solid, plant didn't move an inch.",
    date: "2026-04-18",
  },
  {
    id: "r3",
    productId: "p-string-of-hearts",
    author: "Niamh, Mullingar",
    rating: 5,
    verified: true,
    body: "Such a generous plant for the price, vines already trailing over the shelf.",
    deliveryConditionNote: "Vines were carefully sleeved, zero tangling.",
    date: "2026-05-10",
  },
  {
    id: "r4",
    productId: "p-tree-fern",
    author: "Pádraig, Birr",
    rating: 4,
    verified: true,
    body: "Brilliant specimen. Took a star only because I'd have liked more planting notes — but they answered my email same day.",
    deliveryConditionNote: "Crown well protected for the trip.",
    date: "2026-03-28",
  },
];

export const reviewsFor = (productId) => REVIEWS.filter((r) => r.productId === productId);
export const ratingSummary = (productId) => {
  const rs = reviewsFor(productId);
  if (!rs.length) return { avg: 0, count: 0 };
  const avg = rs.reduce((n, r) => n + r.rating, 0) / rs.length;
  return { avg: Math.round(avg * 10) / 10, count: rs.length };
};
